import React from "react";
import "./MapLocations.css"
import { Link, useHistory, useParams } from "react-router-dom"
import API from "../../utils/API"
import { prepareStageEntry, getDefaultSpawn } from "../../config/worldTransitions";


function Castle() {
    const {id} = useParams()
    const history = useHistory()
    
    return(
        <div className="map-location text-center special castleDiv">
            <img src={require("../../images/mapCastle.jpg")} alt="Castle" className="castle" />
            <Link className="stage-link map-location__control" to={"/castle/" + id} onClick={async (event) => {
                event.preventDefault()
                prepareStageEntry(id, "castle", getDefaultSpawn("castle"))
                try { await API.UpdateSpritePlace("castle", id) } finally { history.push("/castle/" + id) }
            }}>Castle</Link>
        </div>
    )
}

export default Castle;